export function buildFormErrorsFromModelState<TFormData extends object, TErrorData = TFormData>(formData: TFormData, errorResponse: Partial<TErrorData>): Partial<TFormData> {
    // Get the intersection of the form data and model state error response (to ensure we only report errors on registered form fields),
    const [k1, k2] = [Object.keys(formData), Object.keys(errorResponse)]
    const [first, next] = k1.length > k2.length ? [k2, formData] : [k1, errorResponse]
    const commonErrorProps = first.filter(k => k in next)

    return commonErrorProps.reduce((state, prop) => ({ ...state, [prop]: errorResponse[prop] }) , {})
}
